import { ChangeDetectionStrategy, Component, Input, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { IconComponent } from '@mode/capra';
import { CalendlyPopupButtonComponent } from '@mode/shared/ui';
import { Router, RouterModule } from '@angular/router';
import { AnalyticsEvent, AnalyticsService, RunMethodType } from '@mode/shared/util-segment';

@Component({
  selector: 'mode-plan-card',
  standalone: true,
  imports: [CommonModule, IconComponent, CalendlyPopupButtonComponent, RouterModule],
  templateUrl: './plan-card.component.html',
  styleUrls: ['./plan-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanCardComponent {
  @Input() isUpgradePlansFlow = false;
  @Input() isPrimarySignupFlow = true;
  @Input() planIcon = '';
  @Input() planTitle = '';
  @Input() planbuttonValue = '';
  @Input() plantypeValue = '';
  @Input() planDescription = '';
  @Input() planPrice = '';
  @Input() includePlanType = false;
  @Input() includeLabelBusiness = false;
  @Input() includeLabelFree = false;
  @Input() shouldShowNoCreditCard = false;
  @Input() planFeaturesSubhead = '';
  @Input() iconType = '';
  @Input() planFeatures: readonly string[] = [];

  constructor(
    private router: Router,
    private analyticsService: AnalyticsService
  ) {}

  onButtonClick() {
    this.router.navigate(['/organizations/new'], {
      queryParams: {
        flow: 'sign_up',
        plan_type: this.includePlanType ? this.plantypeValue : null,
      },
    });
    this.analyticsService.run(RunMethodType.TrackLink, document.body, AnalyticsEvent.Name.PlanSelectionMade, {
      planType: this.plantypeValue,
    });
  }

  openBookCall(): void {
    this.router.navigate(['/signup/plans/book_call']);
  }

  goBack(): void {
    window.history.back();
  }
}
